import { mountDominoes } from '../render/three/dominoes/domino-game-app.js';

mountDominoes({ name: 'Draw Dominoes', mode: 'draw' }).catch((err) => {
  console.error('failed to mount draw dominoes', err);
});
